import React, { useCallback, useEffect, useState } from 'react';
import './LifelineOrderDetails.scss';
import { OrderBasicInfo } from '../../../widgets/Order';
import { Loader, Modal } from '../../../../UiKit';
import { User } from '../../../widgets';
import { useHistory } from 'react-router-dom';
import {
  ORDER_EVENTS,
  sendReloadOrderEvent,
  sendClubbedOrderEvents,
} from '../../../../helpers/analytics/order.analytics';
import { popUpClosedEvent } from '../../../../analytics/events';
import {
  EventType,
  MetricsForJumboEvent,
} from '../../../../analytics/constants';

let timerID = null;

export const DeletedOrderDetails = ({
  order = null,
  activeOrderId = null,
  userId = null,
  cartId = null,
  orderInfo = null,
  searchType = '',
  issueSubmission,
  refundWarning,
  setSearchValue = () => {},
  getOrderBasicInfo = () => {},
}) => {
  const [isLoading, setLoading] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [orderId, setOrderId] = useState(activeOrderId);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const idsForJumboEvents = {
    [MetricsForJumboEvent.order_id]: orderId,
    [MetricsForJumboEvent.customer_id]: userId,
    [MetricsForJumboEvent.cart_id]: cartId,
  };
  const history = useHistory();

  const orderBasicInfo =
    orderId && orderInfo && orderInfo[orderId] ? orderInfo[orderId] : null;

  let customClass = order?.selected_order ? 'borderRed' : '';

  const reloadOrder = useCallback(
    (order_id) => {
      sendReloadOrderEvent(order_id, userId);
      setLoading(true);
      timerID = setTimeout(() => {
        getOrderBasicInfo(order_id, userId);
        setLoading(false);
      }, 500);
    },
    [userId, getOrderBasicInfo],
  );

  useEffect(() => {
    if (orderId) {
      getOrderBasicInfo(orderId, userId);
    }
    return () => {
      clearTimeout(timerID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const updateTime = setTimeout(() => {
      setIsTimeOut(true);
    }, 300000);
    return () => {
      clearTimeout(updateTime);
    };
  }, [isTimeOut]);

  const setQueryParams = useCallback(
    (replaceOrderId) => {
      const path = history.location.pathname;
      history.replace(`${path}?type=${searchType}&value=${replaceOrderId}`);
    },
    [history, searchType],
  );

  const getBasicOrderInfoForGivenId = useCallback(
    (order_id) => {
      sendClubbedOrderEvents(
        ORDER_EVENTS.GET_REPLACE_ORDER_BASIC_INFO,
        orderId,
        userId,
        {
          replace_order_id: String(order_id),
        },
      );
      if (searchType === 'order_id') {
        setSearchValue(order_id);
        setQueryParams(order_id);
      }
      setOrderId(order_id);
      reloadOrder(order_id);
    },
    [orderId, userId, searchType, setSearchValue, reloadOrder, setQueryParams],
  );

  const closeModal = () => {
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: popupData?.popUpType,
      ...idsForJumboEvents,
    });
    setPopupData(null);
  };

  return (
    <div className={`lifelineDetailContainer col ${customClass} tw-relative`}>
      {isLoading ? (
        <div className='individualOrderloader'>
          <Loader />
        </div>
      ) : (
        <div className='orderDetailWrapper '>
          <div className='orderDetail'>
            {issueSubmission?.orderId === orderId &&
            issueSubmission?.hasSubmission ? (
              <div className='individualOrderloader'>
                <Loader />
              </div>
            ) : (
              <>
                <div className='top'>
                  <OrderBasicInfo
                    orderId={orderId}
                    userId={userId}
                    order={orderBasicInfo?.order}
                    getReplaceOrderBasicInfo={getBasicOrderInfoForGivenId}
                  />
                </div>
                <div className='middle'>
                  <div className='leftSection'>
                    <div className='userSection'>
                      <User
                        orderId={orderId}
                        userId={userId}
                        refundWarning={refundWarning}
                        showCxContext={false}
                      />
                    </div>
                  </div>
                </div>
                <div className=' tw-items-center tw-justify-center tw-text-400 tw-font-medium tw-text-red-700 tw-bg-red-100 tw-py-4 '>
                  This order has been deleted by the customer.
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {popupData?.show && (
        <Modal
          isVisible={popupData?.show}
          type={popupData?.size}
          title={
            popupData?.title && popupData?.titleStyle ? (
              <div style={{ ...popupData?.titleStyle }}>{popupData.title}</div>
            ) : (
              <>{popupData.title}</>
            )
          }
          maxHeight={popupData?.maxHeight}
          minHeight={popupData?.minHeight}
          handleClose={closeModal}
          component={popupData.component}
          showScrollBar={popupData?.showScrollBar}
          paddingTop={popupData?.paddingTop}
          padding={popupData?.padding}
          containerStyles={popupData?.containerStyles}
        />
      )}
    </div>
  );
};
